import { getAxiosClient } from "../../axios-client";
import { GetAllUsersRequestBody, GetAllUsersResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllUsers = async (body: GetAllUsersRequestBody) => {
  return await axiosClient.ax.post<GetAllUsersResponse>(
    "/Users/GetAll",
    body
  );
};
